import { useEffect, useRef, useState } from "react";

/** W3 (26 Oct 2026): scanner tables re-rank every poll, so the row under the pointer could move between seeing it
 *  and clicking it (a Box click opened a different row in the 26 Oct live test). While the pointer is over a table
 *  its rows are held as last seen; `missed` counts the polls not shown, and they appear the moment it leaves.
 *  Display only: whatever is clicked is re-validated live by its ticket / builder / Add. */
export function useHeldRows(rows) {
  const [held, setHeld] = useState(null);
  const [missed, setMissed] = useState(0);
  const latest = useRef(rows);
  useEffect(() => {
    if (held && rows !== latest.current) setMissed((n) => n + 1);
    latest.current = rows;
  }, [rows]);           // eslint-disable-line react-hooks/exhaustive-deps
  const bind = {
    onMouseEnter: () => { setHeld(latest.current); setMissed(0); },
    onMouseLeave: () => { setHeld(null); setMissed(0); },
  };
  return { rows: held || rows, held: !!held, missed, bind };
}

/** The one-line note a held table shows above itself. */
export function heldNote(h) {
  return h.held ? `Updates paused while the pointer is on the table${h.missed ? ` (${h.missed} newer)` : ""}` : null;
}
